import ScaleLoader from "react-spinners/ScaleLoader";

interface LoadingSpinnerProps {
    color?: string;
};
const LoadingSpinner = ({ color }: LoadingSpinnerProps) => {
    return <ScaleLoader color={color || "white"}/>;
};

export default LoadingSpinner;